import { ENV } from "../Utils";

export class User {
  baseApi = ENV.BASE_API;

  async getMe(token) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.USER_ME}`;
      const params = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) {
        throw new Error(result.message);
      }

      return result;
    } catch (error) {
      console.log(error);
    }
  }

  async createUser(accessToken, formValue) {
    //creo try carch comenzando con un dromData
    try {
      const formData = new FormData();

      formData.append("avatar", formValue.fileAvatar);
      formData.append("firstname", formValue.firstname);
      formData.append("lastname", formValue.lastname);
      formData.append("email", formValue.email);
      formData.append("password", formValue.password);
      formData.append("role", formValue.role);
      if (formValue.idClient) {
        formData.append("idClient", formValue.idClient);
      }
      if (formValue.active) {
        formData.append("idClient", formValue.active);
      }

      const url = `${this.baseApi}/${ENV.API_ROUTES.USER}`;
      const params = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) {
        // 200 es un estatus de creacion de un recurso
        throw new Error(result.message);
      }
      return result;
    } catch (error) {
      console.log(error);
    }
  }

  async getUsers(accessToken, active = undefined) {
    //envolvemos todo en un try catch
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.USERS}?active=${active}`;
      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) {
        throw new Error(result.message);
      }
      return result;
    } catch (error) {
      console.log(error);
    }
  }

  async updateUser(accessToken, idUser, userData) {
    try {
      const data = userData;
      //console.log("data", data);
      const formData = new FormData();
      if (data.fileAvatar) {
        formData.append("avatar", data.fileAvatar);
      }
      if (data.avatar) {
        formData.append("avatar", data.avatar);
      }
      if (data.firstname) {
        formData.append("firstname", data.firstname);
      }
      if (data.lastname) {
        formData.append("lastname", data.lastname);
      }
      // Condicional para agregar idClient solo si existe y tiene valor
      if (data.idClient) {
        formData.append("idClient", data.idClient);
      }
      if (data.email) {
        formData.append("email", data.email);
      }
      // Si hay contraseña, se incluye en el formData
      if (data.password) {
        formData.append("password", data.password);
      }
      if (data.country) {
        formData.append("country", data.country);
      }
      if (data.address) {
        formData.append("address", data.address);
      }
      if (data.phone) {
        formData.append("phone", data.phone);
      }
      if (data.role) {
        formData.append("role", data.role);
      }

      //console.log("formData", formData);
      const url = `${ENV.BASE_API}/${ENV.API_ROUTES.USER}/${idUser}`;
      const params = {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) {
        throw new Error(result.message);
      }
      return result;
    } catch (error) {
      console.log(error);
    }
  }

  async updateUserActive(accessToken, idUser, userData) {
    try {
      const url = `${ENV.BASE_API}/${ENV.API_ROUTES.USER}/${idUser}`;
      const params = {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json", // Añadir el Content-Type correcto
        },
        body: JSON.stringify(userData),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) {
        throw new Error(result.message);
      }
      return result;
    } catch (error) {
      console.log(error);
    }
  }

  async deleteUser(accessToken, idUser) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.USER}/${idUser}`;
      const params = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) {
        throw new Error(result.message);
      }
      return result;
    } catch (error) {
      throw error;
    }
  }

  async deleteAvatar(accessToken, avatarUrl) {
    try {
      const url = `${this.baseApi}/user/delete-avatar`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ avatarUrl }),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) {
        throw new Error(result.message);
      }
      return result;
    } catch (error) {
      console.log(error);
    }
  }
}
